import { IPaymentMethod } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const paymentMethodApi = crudEndpointsFactory<IPaymentMethod>()('payment-methods', 'PaymentMethods');
